var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddclent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3755 5V11.25M27.5005 8.125H21.2505M6.47546 19.12C4.90296 20.0425 0.781709 21.9238 3.29171 24.2775C4.51921 25.4275 5.88421 26.25 7.60171 26.25H17.3992C19.1167 26.25 20.483 25.4275 21.708 24.2775C24.2192 21.9238 20.098 20.0412 18.5255 19.12C16.6949 18.0587 14.6164 17.4998 12.5005 17.4998C10.3845 17.4998 8.30604 18.0587 6.47546 19.12ZM17.5005 8.75C17.5005 10.0761 16.9737 11.3479 16.036 12.2855C15.0983 13.2232 13.8265 13.75 12.5005 13.75C11.1744 13.75 9.90261 13.2232 8.96492 12.2855C8.02724 11.3479 7.50046 10.0761 7.50046 8.75C7.50046 7.42392 8.02724 6.15215 8.96492 5.21447C9.90261 4.27678 11.1744 3.75 12.5005 3.75C13.8265 3.75 15.0983 4.27678 16.036 5.21447C16.9737 6.15215 17.5005 7.42392 17.5005 8.75Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddclent);
export default __webpack_public_path__ + "static/media/addclent.071d4fdf953aef0c99fcfc81e63a7d91.svg";
export { ForwardRef as ReactComponent };